import { atom } from 'recoil';

export const ShowSideBarState = atom({
    key: 'ShowSideBarState', 
    default: true, 
});